// const phone1 = '111222333'
// const phone2 = '+34111222333'
// const phone3 = '+1 111 222 3334'
// const phone4 = '+351 111 222 333'

// export const formatPhoneNumber = (phone: string) => {
//   // remove spaces
//   const parsedString = phone.toLowerCase().split(' ').join('')

//   // Regex validation
//   const regex = new RegExp('^((\\d{3}|[+](\\d{2}|\\d{3})\\d{3})\\d{6})$')
//   const isValid = phone.match(regex)
//   console.log(isValid)

//   if (!isValid) {
//     return ''
//   }

//   if (parsedString.split('')[0] === "+") {
//     if (parsedString.length === 13) {
//       const formattedPhone = parsedString.slice(0,3) + ' ' + parsedString.slice(3, 6) + ' ' + parsedString.slice()
//     }
//   }
// }

import { isPossiblePhoneNumber, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'

export function formatPhoneNumberHelper(phoneNumber) {
  if (!phoneNumber) {
    return phoneNumber
  }

  // remove first character if it is +
  if (phoneNumber.slice(0, 1) === '+') {
    phoneNumber = phoneNumber.slice(1)
  }

  if (phoneNumber.length === 9) {
    return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  const phoneNumberWithPrefix = `+${phoneNumber}`
  // const isValid = isValidPhoneNumber(phoneNumberWithPrefix)
  const isPossible = isPossiblePhoneNumber(phoneNumberWithPrefix)

  if (!isPossible) {
    return phoneNumberWithPrefix
  }

  const parsedNumber = parsePhoneNumber(phoneNumberWithPrefix)
  if (!parsedNumber) {
    return null
  }

  const countryCode = parsedNumber.countryCallingCode
  const nationalNumber = parsedNumber.nationalNumber

  let formattedNumber

  if (countryCode.length === 1) {
    formattedNumber = `(+${countryCode}) ${nationalNumber.slice(0, 3)} ${nationalNumber.slice(
      3,
      6
    )} ${nationalNumber.slice(6)}`
  } else if (countryCode.length === 2) {
    formattedNumber = `(+${countryCode}) ${nationalNumber.slice(0, 3)} ${nationalNumber.slice(
      3,
      6
    )} ${nationalNumber.slice(6, 9)} ${nationalNumber.slice(9)}`
  } else if (countryCode.length === 3) {
    formattedNumber = `(+${countryCode}) ${nationalNumber.slice(0, 3)} ${nationalNumber.slice(
      3,
      6
    )} ${nationalNumber.slice(6, 9)} ${nationalNumber.slice(9)}`
  } else {
    formattedNumber = `${nationalNumber.slice(0, 3)} ${nationalNumber.slice(
      3,
      6
    )} ${nationalNumber.slice(6, 9)}`
  }

  return formattedNumber
}

export function normalizePrefixValueHelper(prefixValue: string) {
  if (!prefixValue) {
    return prefixValue
  }
  let normalizedValue = prefixValue.replace(/[^0-9+]/g, '')

  // Si empieza con 00, convertir a formato + y permitir hasta 4 caracteres total
  if (normalizedValue.startsWith('00')) {
    const countryCode = normalizedValue.substring(2, 5) // Extraer hasta 3 dígitos después del 00
    normalizedValue = '+' + countryCode // Convertir 0034 → +34
  }
  // Si empieza con +, permitir hasta 4 caracteres
  else if (normalizedValue.startsWith('+')) {
    normalizedValue = normalizedValue.substring(0, 4) // +XXX = 4 caracteres
  }
  // Si no empieza correctamente, agregar + por defecto
  else if (normalizedValue.length > 0) {
    normalizedValue = '+' + normalizedValue.substring(0, 3)
  }

  return normalizedValue
}

// Función helper para sanitizar el número de teléfono
export const sanitizePhoneNumber = (phoneNumber: string): string => {
  // Remover todos los espacios, guiones y caracteres no numéricos
  return phoneNumber.replace(/[^\d]/g, '') // para guardar solo dígitos en BBDD
}
